import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Loader } from '.';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { IframePage } from "../types/iframe";
import { withParamsFrame } from "../HOCs";
import { getReviewIFrameUrl } from 'redux/sellers/actions';
import { ReactComponent as ReviewsIcon } from 'assets/icons/new/Chapters/Reviews.svg';

const AiReviews: React.FC<IframePage> = ({}) => {
    const [loaded, setLoaded] = React.useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { sellerId, iframeUrl, isAiClient, isLoading } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        iframeUrl: sellers.currentSeller.info.data?.aiIFrameUrl,
        isAiClient: sellers.currentSeller.info.data?.isAiClient,
        isLoading: sellers.currentSeller.info.isLoading,
    }));

    React.useEffect(() => {
        if (sellerId && isAiClient && !iframeUrl) {
            dispatch(getReviewIFrameUrl(sellerId) as any);
        }
    }, [dispatch, sellerId, iframeUrl, isAiClient]);

    if (isLoading) {
        return <Loader />;
    }

    if (!isAiClient) {
        return (
            <div className="flex items-center justify-center page-iframe px-4">
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-10 max-w-md w-full text-center">
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 dark:bg-gray-700 text-c-blue">
                            <ReviewsIcon style={{ width: '32px', height: '32px' }} className="fill-current" />
                        </div>
                    </div>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">
                        {t('aiReviews_title')}
                    </h2>
                    <p className="text-gray-500 dark:text-gray-400 mb-8">
                        {t('aiReviews_description1')}
                    </p>
                    <p className="text-gray-500 dark:text-gray-400 mb-8">
                        {t('aiReviews_description2')}
                    </p>
                    <button
                        onClick={() => navigate(`/${sellerId}/ai-reviews/register`)}
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-c-blue hover:opacity-90 text-white text-sm font-semibold rounded-lg transition-opacity"
                    >
                        {t('aiReviews_setupButton')}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='xs:mx-3'>
                <iframe
                    className={`${!loaded ? 'min-h-[auto]' : 'page-iframe-min'}`}
                    src={`${iframeUrl}`}
                    title="AI Reviews"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}
                    onLoad={() => setLoaded(true)}
                />
            </div>
            {!loaded && <Loader />}
        </>
    );
};

export default withParamsFrame(AiReviews);
